import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/main/balance';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Copy from '../../components/copy';
import {useNavigate} from 'react-router-dom';

export default () => {
    const {wallet} = useSelector(Selector),
          navigate = useNavigate();

    return (
        <div className={`balance_block ${wallet.redflag ? "redflag" : wallet.verificationStatus} ${wallet.cashback.level}`}>
            <div className="balance_id">
                <div className="left-block">
                    <div className="value">ID: {wallet.id}</div>
                    <Copy size={18} value={`My wallet ID is ${wallet.id}`} />
                </div>

                <div className="right-block" onClick={e => {
                    // if(wallet.id !== "1168949833")
                    //     return;

                    return navigate('/verification');
                }}>
                    {wallet.redflag ? (
                        <>
                            Problem account
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="18" height="18" rx="9" fill="white"/>
                                <path d="M9 14C8.44772 14 8 13.5523 8 13V8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8V13C10 13.5523 9.55228 14 9 14Z" fill="#D21A1A"/>
                                <path d="M8.28936 5.71795C8.48227 5.90598 8.7234 6 9.01277 6C9.29078 6 9.5234 5.90598 9.71064 5.71795C9.90355 5.52422 10 5.2849 10 5C10 4.7094 9.90638 4.47009 9.71915 4.28205C9.53192 4.09402 9.29645 4 9.01277 4C8.7234 4 8.48227 4.09402 8.28936 4.28205C8.09645 4.47009 8 4.7094 8 5C8 5.2849 8.09645 5.52422 8.28936 5.71795Z" fill="#D21A1A"/>
                            </svg>
                        </>
                    ) : (
                        <>
                            {wallet.verificationStatus === "unverified" && (
                                <>
                                    Unverified
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.0625 1.83749C8.5875 1.39499 9.435 1.39499 9.945 1.83749L11.13 2.84999C11.355 3.03749 11.7825 3.19499 12.0825 3.19499H13.3575C14.1525 3.19499 14.805 3.84749 14.805 4.64249V5.91749C14.805 6.21749 14.9625 6.63749 15.15 6.86249L16.1625 8.04749C16.605 8.57249 16.605 9.41999 16.1625 9.92999L15.15 11.115C14.9625 11.34 14.805 11.76 14.805 12.06V13.335C14.805 14.13 14.1525 14.7825 13.3575 14.7825H12.0825C11.7825 14.7825 11.3625 14.94 11.1375 15.1275L9.9525 16.14C9.4275 16.5825 8.58 16.5825 8.07 16.14L6.885 15.1275C6.66 14.94 6.2325 14.7825 5.94 14.7825H4.6275C3.8325 14.7825 3.18 14.13 3.18 13.335V12.0525C3.18 11.76 3.03 11.3325 2.8425 11.115L1.83 9.92249C1.395 9.40499 1.395 8.56499 1.83 8.04749L2.8425 6.85499C3.03 6.62999 3.18 6.20999 3.18 5.91749V4.64999C3.18 3.85499 3.8325 3.20249 4.6275 3.20249H5.925C6.225 3.20249 6.645 3.04499 6.87 2.85749L8.0625 1.83749Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 6.09753V9.72003" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.99588 12H9.00262" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </>
                            )}

                            {wallet.verificationStatus === "verification-pending" && (
                                <>
                                    Verification pending
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.3063 15.3495C13.345 14.5491 15.5834 11.7866 15.5834 8.49996C15.5834 4.58996 12.4384 1.41663 8.50002 1.41663C3.77544 1.41663 1.41669 5.35496 1.41669 5.35496M1.41669 5.35496V2.12496M1.41669 5.35496H2.84044H4.56169" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.41669 8.5C1.41669 12.41 4.59002 15.5833 8.50002 15.5833" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3 3"/>
                                    </svg>
                                </>
                            )}

                            {wallet.verificationStatus === "verified" && (
                                <>
                                    Verified
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.28497 9.00006L8.09247 10.8151L11.715 7.18506" stroke="#0B0B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8.06247 1.83749C8.57997 1.39499 9.42747 1.39499 9.95247 1.83749L11.1375 2.85749C11.3625 3.05249 11.7825 3.20999 12.0825 3.20999H13.3575C14.1525 3.20999 14.805 3.86249 14.805 4.65749V5.93249C14.805 6.22499 14.9625 6.65249 15.1575 6.87749L16.1775 8.06249C16.62 8.57999 16.62 9.42749 16.1775 9.95249L15.1575 11.1375C14.9625 11.3625 14.805 11.7825 14.805 12.0825V13.3575C14.805 14.1525 14.1525 14.805 13.3575 14.805H12.0825C11.79 14.805 11.3625 14.9625 11.1375 15.1575L9.95247 16.1775C9.43497 16.62 8.58747 16.62 8.06247 16.1775L6.87747 15.1575C6.65247 14.9625 6.23247 14.805 5.93247 14.805H4.63497C3.83997 14.805 3.18747 14.1525 3.18747 13.3575V12.075C3.18747 11.7825 3.02997 11.3625 2.84247 11.1375L1.82997 9.94499C1.39497 9.42749 1.39497 8.58749 1.82997 8.06999L2.84247 6.87749C3.02997 6.65249 3.18747 6.23249 3.18747 5.93999V4.64999C3.18747 3.85499 3.83997 3.20249 4.63497 3.20249H5.93247C6.22497 3.20249 6.65247 3.04499 6.87747 2.84999L8.06247 1.83749Z" stroke="#0B0B0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>

                                </>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div className="balance">
                <div className="balance-value">
                    <div className="symbol">$</div>
                    <div className="amount">{wallet.balance.toFixed(2)}</div>
                </div>

                <div className="lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>

            {['verification-pending', 'verified'].includes(wallet.verificationStatus) && (
                <div className="name-block">{wallet.verificationData.name}</div>
            )}
        </div>
    )
}